<template>
    <CarouselSlide class="insurance-companies-slide">
        <img src="/images/promo/interface-slider/insurance-companies-slide.png" alt="Insurance companies statistics interface" />
    </CarouselSlide>
</template>

<script>
import { CarouselSlide } from '@/shared/ui/slider';

export default {
  components: { CarouselSlide },
};
</script>

<style lang="scss" scoped>
.insurance-companies-slide {
  border: 1px solid #CADDFC;
  border-radius: 16px;
  overflow: hidden;
}
</style>
